var map = {
	"./Alipay.png": "d71d",
	"./Bg.png": "00c8",
	"./Bg1.png": "0589",
	"./Bg2.png": "4acc",
	"./Fill.png": "7b2a",
	"./ID.png": "6421",
	"./Rectangle.png": "e42c",
	"./WehcatPay.png": "e6e8",
	"./alert.png": "9c01",
	"./azlogoimg.png": "43f1",
	"./birthday.png": "5311",
	"./blackstar.png": "8bbc",
	"./camera.png": "63bb",
	"./city.png": "3a0b",
	"./close.png": "c821",
	"./closeModel.png": "bbc8",
	"./down_arrow.png": "21a4",
	"./edit.png": "0f8f",
	"./exclamation.png": "1729",
	"./exquestion.png": "11dc",
	"./hot.png": "4233",
	"./huanyihuan.png": "098d",
	"./ioslogoimg.png": "4850",
	"./login1.png": "f35b",
	"./login10.png": "91e6",
	"./login11.png": "8d1e",
	"./login2.png": "33ff",
	"./login3.png": "98d9",
	"./login4.png": "749e",
	"./login5.png": "c29c",
	"./login6.png": "15d9",
	"./login7.png": "15bc",
	"./login8.png": "a461",
	"./login9.png": "88ac",
	"./logo.png": "e0dd",
	"./magnify.png": "8b35",
	"./man.png": "6ae2",
	"./pay.png": "0b06",
	"./payTick.png": "f127",
	"./point.png": "de1d",
	"./pop.png": "8cd8",
	"./question.png": "623c",
	"./refresh.png": "13fa",
	"./sex.png": "7e4a",
	"./shape.png": "4246",
	"./shrink.png": "01c3",
	"./star.png": "f7dc",
	"./wallet.png": "8465",
	"./yellowstar.png": "f2e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";